import React from 'react';
import { reduxForm, Field } from 'redux-form';

import { formatSaveStatus } from '../helpers/formatters';
import FormError from './FormError';
import InputField from './InputField';
import CheckboxField from './CheckboxField';
import DateTimePicker from './DateTimePicker';

const CustomPlanPricingForm = ({
  handleSubmit,
  initialValues,
  saveStatus,
  isUpdateModal = false,
  error,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field component={InputField} name="att_plan" disabled={isUpdateModal} />
      {isUpdateModal && (
        <Field
          component={InputField}
          name="tracfone_plan"
          disabled={isUpdateModal}
        />
      )}
      <Field component={InputField} name="simo_plan" disabled={isUpdateModal} />
      <Field
        component={InputField}
        name="quick_plan"
        disabled={isUpdateModal}
      />
      <Field
        component={InputField}
        name="user_profile"
        disabled={isUpdateModal}
      />
      <Field component={InputField} name="price" required={!isUpdateModal} />
      <Field component={InputField} name="activation_fee" />
      <Field
        component={DateTimePicker}
        name="effective_start_at"
        disabled={isUpdateModal}
      />
      <Field component={CheckboxField} name="is_visible" />

      {!isUpdateModal && (
        <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
          Create Pricing
        </button>
      )}

      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>

      {error && <FormError error={error} />}
    </form>
  </div>
);

export default reduxForm({
  form: 'customPlanPricing',
})(CustomPlanPricingForm);
